import { setBreakPoints } from 'nui/src/components/Breakpoint/Breakpoint.hooks';

setBreakPoints({
  xsmall: 320,
  small: 600,
  medium: 768,
  large: 1280,
  xlarge: 1810,
  xxlarge: 1920,
});

export * from 'nui/src/components/Breakpoint/Breakpoint.hooks';
